import { PaletteOptions } from 'components/base/system/theme';
import {
  primary,
  secondary,
  text,
  error,
  info,
  warning,
  success,
  action,
  common,
  background,
  custom1,
  custom2,
  grey,
  other,
  normalText,
  divider,
} from 'assets/colors/colors';

export const themePalette: PaletteOptions = {
  primary,
  secondary,
  text,
  error,
  info,
  warning,
  success,
  action,
  common,
  background,
  grey,
  custom1,
  custom2,
  other,
  normalText,
  divider,
};
